import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const SendToIsfDialog: FC<any> = ({ openSendToISF, setOpenSendToISF, taskId, setIsSentToIsf }: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = React.useState(false);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }
  const dispatch = useDispatch();

  const handleCloseRejectDialog = () => {
    setOpenSendToISF(false);
  };

  const Data = {
    action_name: 'Sent To ISF',
    sent_to_isf: true,
    is_resolved: false,
    updated_by: userName
  };

  const handleConfirmClick = async () => {
    setProcessing(true);
    const response = await docService.sendToISF(
      documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
      Data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel,
      'DocumentApproval',
      documentDetail.data[0].tmf_document_name,
      false,
      false
    );
    if (response?.data) {
      setProcessing(false);
      setOpenSendToISF(false);
      setIsSentToIsf(true);
      store.dispatch(setSnackbarMessage('Document sent to ISF successfully.', 'success'));
      setDocumentDetail(dispatch, [{ ...documentDetail.data[0], sent_to_isf: true }]);
    } else {
      setProcessing(false);
      setOpenSendToISF(false);
      store.dispatch(setSnackbarMessage('Error in Sending To ISF.', 'error'));
    }
  };

  return (
    <React.Fragment>
      <PopupComponent
        open={openSendToISF}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Send to ISF</DialogTitle>
        <DialogContent>
          {isProcessing && (
            <Box sx={{ width: '100%' }} mb={2}>
              <LinearProgress />
            </Box>
          )}
          <DialogContentText id="alert-dialog-description">
            {`Document`}
            <span style={{ fontWeight: 'bold' }}>
              {` '${documentDetail.data[0]?.tmf_document_name}'`}
              <span style={{ fontWeight: 200 }}>{` will be moved to ISF`}</span>
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRejectDialog} disabled={isProcessing}>
            Cancel
          </Button>
          <Button autoFocus onClick={handleConfirmClick} disabled={isProcessing}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(SendToIsfDialog);
